import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

export type AppMessageTransport = { applicationId: string; enabled: boolean; connected: boolean };
export type AppMessageReceipt = { requestId: string; deliveryState: "sending" | "accepted" | "rejected" | "unconfirmed"; message?: string };

export async function loadAppMessageTransport(applicationId: string): Promise<AppMessageTransport | null> {
  // Additive rollout RPC can be absent while the previous release remains live.
  const { data, error } = await (supabase as SupabaseClient).rpc("get_app_message_transport", { p_app_id: applicationId });
  if (error) return null;
  return { applicationId, enabled: data?.enabled === true, connected: data?.connected === true };
}

export async function sendIndependentAppMessage(applicationId: string, requestId: string, text: string,
  invoke: <T>(name: string, body: Record<string, unknown>) => Promise<T>,
): Promise<AppMessageReceipt> {
  const receipt = await invoke<AppMessageReceipt>("submit-app-message", { applicationId, requestId, text });
  if (receipt?.requestId !== requestId || !["sending", "accepted", "rejected", "unconfirmed"].includes(receipt.deliveryState)) {
    throw new Error("Message delivery returned no matching receipt");
  }
  return receipt;
}
